<template lang="pug">
section.always-on
  .blocks.two-cols
    .block
      h3 Dostawcy
      .block-content VW / Audi / Seat / Skoda / Ford / Opel / Renault / Peugeot / Citroen / Mercedes / BMW / Fiat / / Nissens / Elring / SKF / Reinz / INA / Bilstein / Beru / Sachs / Bosch / ContiTech / Ruville / Ferodoo / Brembo / Purflux / NGK / Corteco / Hepu / Mobil / Castrol / TRW / Valeo / GKN / Mann / Goetze / Śląsk Auto / ATE / Lemforder / Kella

    .block
      h3(style="visibility: hidden;") &nbsp;
      .block-content(style="background: none;")
        .dostawcy
</template>

<script>
export default {
name: "Dostawcy"
}
</script>

<style scoped>
.dostawcy {
  background-image: url("../assets/dostawcy.jpg");
  background-size: cover;
  width: 530px;
  height: 366px;
}
</style>
